export const notFoundPageTranslations = {
    'en': {
        'NOT_FOUND_PAGE_TITLE': 'Error',
        'NOT_FOUND_PAGE_TEXT': 'Page not found',
        'NOT_FOUND_PAGE_GO_BACK': 'Go back',
        'NOT_FOUND_PAGE_GO_HOME': 'Go home',
    },
    'ru': {
        'NOT_FOUND_PAGE_TITLE': 'ÐÑÐ¸Ð±ÐºÐ°',
        'NOT_FOUND_PAGE_TEXT': 'Ð¡ÑÑÐ°Ð½Ð¸ÑÐ° Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð°',
        'NOT_FOUND_PAGE_GO_BACK': 'ÐÐ°Ð·Ð°Ð´',
        'NOT_FOUND_PAGE_GO_HOME': 'ÐÐ° Ð³Ð»Ð°Ð²Ð½ÑÑ',
    }
};
